module.exports = __webpack_public_path__ + "static/media/peoples.379cba23.svg";